import * as React from 'react'
import { COUNTRY_SHORTCODES } from '../../../constants'
import { USA } from './Countries'

export type Stripe = {
  createToken: (
    cardElement: string,
    data: object
  ) => Promise<{
    error: string
    token: string
  }>
}

type AddBankAccountProps = {
  country: keyof typeof COUNTRY_SHORTCODES
  stripe?: Stripe
}

export const AddBankAccount: React.FC<AddBankAccountProps> = ({
  country,
  stripe,
}) => {
  switch (country) {
    case COUNTRY_SHORTCODES.US:
      return <USA stripe={stripe} />
    default:
      return <USA stripe={stripe} />
  }
}

export default AddBankAccount
